/**
 * Contenido curado del bloque "Tu operación comercial en evolución"
 * (solo escritorio, Home). No es un motor ni una fuente de datos — es la
 * narrativa de percepción aprobada para el estado real conocido de la
 * instancia de Jorge Abel (Renovaciones activo y validado, Venta Cruzada
 * visible/preparada sin WhatsApp conectado, Recovery oculto). Si ese estado
 * cambia (p. ej. se conecta WhatsApp o se activa Recovery), estas etiquetas
 * deben actualizarse a mano — no se derivan automáticamente para evitar
 * afirmar que algo ya opera cuando todavía no es cierto.
 */
export const VISION_TONE = {
  active: "active",
  pending: "pending",
  soon: "soon",
};

export const COMMERCIAL_AGENTS = [
  {
    id: "priority",
    title: "Agente de Prioridad Comercial",
    status: "Activo",
    tone: VISION_TONE.active,
    icon: "target",
    description: "Analiza tu cartera completa y decide quién necesita tu atención primero, cada vez que entras.",
  },
  {
    id: "renewal",
    title: "Agente de Renovaciones",
    status: "Activo",
    tone: VISION_TONE.active,
    icon: "refresh-cw",
    description: "Detecta fechas próximas y prioriza a quién atender primero.",
  },
  {
    id: "cross_sell",
    title: "Agente de Venta Cruzada",
    status: "Preparada para activar",
    tone: VISION_TONE.pending,
    icon: "shuffle",
    description: "Lista para conectarla al WhatsApp empresarial y lanzar la campaña de Siigo Fiscal.",
  },
  {
    id: "recovery",
    title: "Agente de Recuperación",
    status: "Próxima activación",
    tone: VISION_TONE.pending,
    icon: "activity",
    description: "Identificará clientes que dejaron de comprar y organizará el seguimiento.",
  },
  {
    id: "responses",
    title: "Agente de Respuestas",
    status: "Pendiente de WhatsApp",
    tone: VISION_TONE.pending,
    icon: "message-square",
    description: "Reconocerá interesados y actualizará automáticamente la siguiente acción.",
  },
  {
    id: "followup",
    title: "Agente de Seguimiento",
    status: "En preparación",
    tone: VISION_TONE.soon,
    icon: "radar",
    description: "Ayudará a que ninguna conversación comercial quede olvidada.",
  },
  {
    id: "prospecting",
    title: "Agente de Clientes Nuevos",
    status: "Siguiente etapa",
    tone: VISION_TONE.soon,
    icon: "user-plus",
    description: "Incorporará campañas y canales de captación para generar nuevas oportunidades.",
  },
  {
    id: "reports",
    title: "Agente de Reportes Ejecutivos",
    status: "Próximamente",
    tone: VISION_TONE.soon,
    icon: "bar-chart-3",
    description: "Mostrará resultados, oportunidades, conversaciones y cierres.",
  },
  {
    id: "automation",
    title: "Agente de Automatizaciones",
    status: "Configurables por etapas",
    tone: VISION_TONE.soon,
    icon: "workflow",
    description: "Permitirá adaptar flujos a la operación de cada distribuidor o PYME.",
  },
];

export const ACTIVATION_STEPS = [
  "Conectar tu WhatsApp empresarial.",
  "Lanzar una campaña de Siigo Fiscal con clientes de confianza.",
  "Detectar automáticamente quién responde FISCAL.",
  "Priorizar interesados.",
  "Guiarte para agendar demostraciones y dar seguimiento.",
];

/**
 * "Ecosistema en evolución" — visión de producto, no lista de
 * integraciones activas ni oferta comercial. Deliberadamente no incluye
 * ninguna referencia a la infraestructura real que usa Commercial Operator
 * hoy (esa palabra nunca debe ser visible para Jorge Abel) — solo
 * herramientas externas que un distribuidor o PYME reconocería, con
 * estados honestos de hacia dónde va la plataforma.
 */
export const ECOSYSTEM_TIERS = [
  { id: "next", label: "Próxima etapa", items: ["WhatsApp Business"] },
  { id: "priority", label: "Ecosistema prioritario", items: ["Siigo Aspel"] },
  { id: "evaluation", label: "En evaluación", items: ["HubSpot", "Salesforce"] },
  { id: "future", label: "Futuras integraciones", items: ["Meta Ads", "Correo", "Calendarios"] },
];
